import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("h1", null, "Users", -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" New User ")
const _hoisted_3 = /*#__PURE__*/_createVNode("i", { class: "el-icon-plus el-icon-right" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_link = _resolveComponent("el-link")
  const _component_el_container = _resolveComponent("el-container")
  const _component_UsersList = _resolveComponent("UsersList")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_el_container, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_link, {
          class: "el-button",
          href: `/#/users/create/`
        }, {
          default: _withCtx(() => [
            _hoisted_2,
            _hoisted_3
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_UsersList)
  ], 64))
}